<template>
  <main class="container my-5 text-center">

    <h1 class="display-1">
      404
    </h1>

    <h3>
      Page Not Found
    </h3>

    <p class="text-muted">
      The page you are looking for does not exist.
    </p>

    <router-link
      to="/books"
      class="btn btn-primary"
    >
      Back to Books
    </router-link>

  </main>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>